import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { TeamRecord } from "../types";

const commonCellStyles = {
  color: "rgba(255,255,255,0.92)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  borderBottom: "1px solid rgba(255,255,255,0.14)",
};

type TeamsTableProps = {
  filteredCount: number;
  page: number;
  rowsPerPage: number;
  teams: TeamRecord[];
  onTeamClick: (teamId?: string) => void | Promise<void>;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (value: number) => void;
};

const TeamsTable: React.FC<TeamsTableProps> = ({
  filteredCount,
  page,
  rowsPerPage,
  teams,
  onTeamClick,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: "12px",
        overflow: "hidden",
        background:
          "linear-gradient(180deg, rgba(22,23,30,0.84) 0%, rgba(16,17,20,0.9) 100%)",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          background: "transparent",
          border: "none",
          backdropFilter: "blur(4px)",
          borderRadius: 0,
          overflow: "auto",
          flex: 1,
          minHeight: 0,
        }}
      >
        <Table stickyHeader>
          <TableHead
            sx={{
              "& .MuiTableCell-head": {
                background:
                  "linear-gradient(90deg, rgba(72,23,54,0.98) 0%, rgba(103,37,28,0.98) 100%)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "15px",
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              },
            }}
          >
            <TableRow>
              <TableCell>Team</TableCell>
              <TableCell>Team Type</TableCell>
              <TableCell>Players</TableCell>
              <TableCell>Total Purse</TableCell>
              <TableCell>Fund Remaining</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teams
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((team) => (
                <TableRow key={team.Id}>
                  <TableCell sx={commonCellStyles}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {team.Logo_URL__c ? (
                        <Box
                          component="img"
                          src={team.Logo_URL__c}
                          alt={team.Name || "team"}
                          sx={{ width: 26, height: 26, objectFit: "contain" }}
                        />
                      ) : null}
                      <Box
                        component="span"
                        onClick={async () => {
                          await onTeamClick(team.Id);
                        }}
                        sx={{
                          cursor: "pointer",
                          textDecoration: "none",
                          "&:hover": {
                            color: "#fff",
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {team.Name || "--"}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={commonCellStyles}>
                    {(team.Team_Type__c as string) || "--"}
                  </TableCell>
                  <TableCell sx={commonCellStyles}>{team.playerCount ?? "--"}</TableCell>
                  <TableCell sx={commonCellStyles}>
                    {typeof team.Total_Fund__c === "number"
                      ? `₹${team.Total_Fund__c.toLocaleString("en-IN")}`
                      : "--"}
                  </TableCell>
                  <TableCell sx={commonCellStyles}>
                    {typeof team.Fund_Remaining__c === "number"
                      ? `₹${team.Fund_Remaining__c.toLocaleString("en-IN")}`
                      : "--"}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredCount}
        page={page}
        onPageChange={(_, newPage) => onPageChange(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          onRowsPerPageChange(parseInt(e.target.value, 10));
        }}
        sx={{
          color: "#fff",
          borderTop: "1px solid rgba(255,255,255,0.12)",
          pb: 0,
          px: 0,
          flexShrink: 0,
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              color: "#fff",
            },
          "& .MuiInputBase-root": {
            color: "#fff",
          },
          "& .MuiSvgIcon-root": {
            fill: "#fff",
          },
        }}
      />
    </Box>
  );
};

export default TeamsTable;
